import type { LucideIcon } from "lucide-react";

export type { DetailRowFieldType, DetailRowProps } from "./components/DetailRow";
export { DetailRow } from "./components/DetailRow";

/** EmptyBlock 入参 */
export interface EmptyBlockProps {
  /** 占位提示文案 */
  text: string;
}

/** SectionTitle 入参 */
export interface SectionTitleProps {
  icon: LucideIcon;
  /** 分区标题文案 */
  title: string;
}

/** 详情 / 列表区块无数据时的占位块 */
export const EmptyBlock = ({ text }: EmptyBlockProps) => (
  <div className="bg-slate-50 rounded-lg p-4 text-center text-sm text-slate-400">{text}</div>
);

/** 详情弹窗分区标题（图标 + 文案） */
export const SectionTitle = ({ icon: Icon, title }: SectionTitleProps) => (
  <h4 className="text-sm font-semibold mb-3 flex items-center gap-2 m-0">
    <Icon className="w-4 h-4 text-slate-400" />
    {title}
  </h4>
);
